export default __webpack_public_path__ + "static/article-thumbnail-02-5112f7b7fa8fe7ecd1614c396149b244.png";